import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { AbsenceModel } from '../../models/absence.model';
import { BusinessObjectType } from '@core/enums/business-object-type.enum';
import { ROOT_SCOPE_VARIABLES } from '@core/settings/root-scope.settings';
import { AddNewAbsenceEvent } from '../empty-day-box/empty-day-box.component';
import { DriverVehiclePairModel } from '../../models/driver-vehicle-pair.model';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'absence-day-box',
  standalone: false,
  templateUrl: './absence-day-box.component.html',
  styleUrls: ['./absence-day-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbsenceDayBoxComponent implements OnChanges {
  @Input({ required: true }) absences!: AbsenceModel[];
  @Input({ required: true }) driver!: DriverVehiclePairModel;

  @Output() addNewAbsence = new EventEmitter<AddNewAbsenceEvent>;

  @ViewChild('menuTrigger') contextMenuTrigger!: MatMenuTrigger;

  scheduleAbsences!: AbsenceModel[];
  calendarAbsences!: AbsenceModel[];
  businessObjectType = BusinessObjectType;
  PERM = ROOT_SCOPE_VARIABLES.PERMISSIONS.UNAVAILABILITY;

  ngOnChanges(): void {
    this.scheduleAbsences = this.absences!.filter(a => a.sourceType === 'ScheduledAbsence');
    this.calendarAbsences = this.absences!.filter(a => a.sourceType === 'CalendarEvent');
  }

  contextClick($event: MouseEvent): void {
    if (!$event.shiftKey) {
      $event.preventDefault();
      this.contextMenuTrigger.openMenu();
    }
  }

  onAddAbsenceClick(objectType: BusinessObjectType, objectId: number): void {
    this.addNewAbsence.emit({ objectType, objectId });
  }
}
